import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = { range: '_rangeAggregation' };
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _bulkCreateItemResult = { item: '_item' };
var _bulkCreateItemsRequest = { items: '_item' };
var _bulkCreateItemsResponse = { results: '_bulkCreateItemResult' };
var _bulkDeleteItemsRequest = {};
var _bulkDeleteItemsResponse = {};
var _bulkItemResult = { item: '_item' };
var _bulkUpdateItemRequest = { items: '_maskedItem' };
var _bulkUpdateItemResponse = { results: '_bulkItemResult' };
var _cloneItemsRequest = {};
var _cloneItemsResponse = {};
var _countItemsRequest = {};
var _countItemsResponse = {};
var _createItemRequest = { item: '_item' };
var _createItemResponse = { item: '_item' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deleteItemRequest = {};
var _deleteItemResponse = {};
var _duplicateItemRequest = {};
var _duplicateItemResponse = {};
var _externalReferenceInfo = { lastSyncDate: 'google.protobuf.Timestamp' };
var _getItemRequest = {};
var _getItemResponse = { item: '_item' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _item = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    image: '_image',
    additionalImages: '_image',
    externalReferenceInfo: '_externalReferenceInfo',
};
var _listItemsRequest = {};
var _listItemsResponse = { items: '_item' };
var _maskedItem = { mask: 'google.protobuf.FieldMask', item: '_item' };
var _queryItemsRequest = {};
var _queryItemsResponse = { items: '_item' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _scalarResult = { value: 'DOUBLE' };
var _searchItemsRequest = { search: '_cursorSearch' };
var _searchItemsResponse = {
    items: '_item',
    aggregationData: '_aggregationData',
};
var _updateItemRequest = { mask: 'google.protobuf.FieldMask', item: '_item' };
var _updateItemResponse = { item: '_item' };
function resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-item',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemRestaurantsDuplicateItemUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-item',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-item',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/items',
                destPath: '/v1/bulk/items',
            },
            {
                srcPath: '/restaurants/menus/v1/items',
                destPath: '/v1/items',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function duplicateItem(payload) {
    var _a = serializer(_duplicateItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_duplicateItemResponse, {}).fromJSON;
    function __duplicateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.restaurants_duplicate_item.RestaurantsDuplicateItem.DuplicateItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemRestaurantsDuplicateItemUrl({ protoPath: '/v1/items/{id}/duplicate', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __duplicateItem.fromReq = fromReq;
    __duplicateItem.__isAmbassador = true;
    return __duplicateItem;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates an item.
 *
 * To create multiple items at once, use [Bulk Create Items](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-create-items).
 */
export function createItem(payload) {
    var _a = serializer(_createItemRequest, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createItemResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __createItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CreateItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createItem.fromReq = fromReq;
    __createItem.__isAmbassador = true;
    return __createItem;
}
/**
 * > **Note:** The Items API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple items at once.
 */
export function bulkCreateItems(payload) {
    var _a = serializer(_bulkCreateItemsRequest, { _externalReferenceInfo: _externalReferenceInfo, _image: _image, _item: _item }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateItemsResponse, {
        _bulkCreateItemResult: _bulkCreateItemResult,
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __bulkCreateItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkCreateItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/bulk/items/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateItems.fromReq = fromReq;
    __bulkCreateItems.__isAmbassador = true;
    return __bulkCreateItems;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves an item by ID.
 */
export function getItem(payload) {
    var _a = serializer(_getItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getItemResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __getItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.GetItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getItem.fromReq = fromReq;
    __getItem.__isAmbassador = true;
    return __getItem;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 items.
 */
export function listItems(payload) {
    var _a = serializer(_listItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listItemsResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __listItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.ListItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listItems.fromReq = fromReq;
    __listItems.__isAmbassador = true;
    return __listItems;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of items given the provided paging, filtering, and sorting. Up to 500 items can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/supported-filters-and-sorting) article. To learn how to query items, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryItems(payload) {
    var _a = serializer(_queryItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryItemsResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __queryItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.QueryItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryItems.fromReq = fromReq;
    __queryItems.__isAmbassador = true;
    return __queryItems;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of items given the provided filtering, paging, and sorting.
 *
 * ## Defaults
 * Search Items has the following default settings, which you can override:
 *
 * - Sorted by `createdDate` in ascending order.
 * - `paging.limit` set to `500`.
 * - `paging.offset` set to `0`.
 */
export function searchItems(payload) {
    var _a = serializer(_searchItemsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchItemsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResults: _rangeResults,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.SearchItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                        protoPath: '/v1/items/search',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __searchItems.fromReq = fromReq;
    __searchItems.__isAmbassador = true;
    return __searchItems;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of items that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all items.
 */
export function countItems(payload) {
    var _a = serializer(_countItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countItemsResponse, {}).fromJSON;
    function __countItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CountItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countItems.fromReq = fromReq;
    __countItems.__isAmbassador = true;
    return __countItems;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates an item.
 *
 * To update multiple items at once, use [Bulk Update Item](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-update-item)
 *
 * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating the item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
 */
export function updateItem(payload) {
    var _a = serializer(_updateItemRequest, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateItemResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __updateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.UpdateItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/{item.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateItem.fromReq = fromReq;
    __updateItem.__isAmbassador = true;
    return __updateItem;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates up to 100 multiple items at once.
 *
 * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
 */
export function bulkUpdateItem(payload) {
    var _a = serializer(_bulkUpdateItemRequest, { _externalReferenceInfo: _externalReferenceInfo, _image: _image, _item: _item, _maskedItem: _maskedItem }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateItemResponse, {
        _bulkItemResult: _bulkItemResult,
        _externalReferenceInfo: _externalReferenceInfo,
        _image: _image,
        _item: _item,
    }).fromJSON;
    function __bulkUpdateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkUpdateItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/bulk/items/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateItem.fromReq = fromReq;
    __bulkUpdateItem.__isAmbassador = true;
    return __bulkUpdateItem;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes an item.
 */
export function deleteItem(payload) {
    var _a = serializer(_deleteItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteItemResponse, {}).fromJSON;
    function __deleteItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.DeleteItem',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteItem.fromReq = fromReq;
    __deleteItem.__isAmbassador = true;
    return __deleteItem;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple items at once.
 */
export function bulkDeleteItems(payload) {
    var _a = serializer(_bulkDeleteItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteItemsResponse, {}).fromJSON;
    function __bulkDeleteItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkDeleteItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/bulk/items/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteItems.fromReq = fromReq;
    __bulkDeleteItems.__isAmbassador = true;
    return __bulkDeleteItems;
}
/** Clone items from a different metasite. */
export function cloneItems(payload) {
    var _a = serializer(_cloneItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneItemsResponse, {}).fromJSON;
    function __cloneItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CloneItems',
            url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
                protoPath: '/v1/items/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneItems.fromReq = fromReq;
    __cloneItems.__isAmbassador = true;
    return __cloneItems;
}
//# sourceMappingURL=http.impl.js.map